import { IsoField } from '../models/IsoField'

export class FieldUtil {
  public static getDefaultFields() {
    const fieldDefinitions: [string, string][] = [
      ['001', 'Bitmap'],
      ['002', 'Primary account number (PAN)'],
      ['003', 'Processing code'],
      ['004', 'Amount, transaction'],
      ['005', 'Amount, settlement'],
      ['006', 'Amount, cardholder billing'],
      ['007', 'Transmission date & time'],
      ['008', 'Amount, cardholder billing fee'],
      ['009', 'Conversion rate, settlement'],
      ['010', 'Conversion rate, cardholder billing'],
      ['011', 'System trace audit number (STAN)'],
      ['012', 'Time, local transaction (hhmmss)'],
      ['013', 'Date, local transaction (MMDD)'],
      ['014', 'Date, expiration'],
      ['015', 'Date, settlement'],
      ['016', 'Date, conversion'],
      ['017', 'Date, capture'],
      ['018', 'Merchant type/Merchant Category Code'],
      ['019', 'Acquiring institution country code'],
      ['020', 'PAN extended, country code'],
      ['021', 'Forwarding institution. country code'],
      ['022', 'Point of service entry mode'],
      ['023', 'Application PAN sequence number'],
      ['024', 'Function code (ISO 8583:1993)/Network International identifier (NII)'],
      ['025', 'Point of service condition code'],
      ['026', 'Point of service capture code'],
      ['027', 'Authorizing identification response length'],
      ['028', 'Amount, transaction fee'],
      ['029', 'Amount, settlement fee'],
      ['030', 'Amount, transaction processing fee'],
      ['031', 'Amount, settlement processing fee'],
      ['032', 'Acquiring institution identification code'],
      ['033', 'Forwarding institution identification code'],
      ['034', 'Primary account number, extended'],
      ['035', 'Track 2 data'],
      ['036', 'Track 3 data'],
      ['037', 'Retrieval reference number'],
      ['038', 'Authorization identification response'],
      ['039', 'Response code'],
      ['040', 'Service restriction code'],
      ['041', 'Card acceptor terminal identification'],
      ['042', 'Card acceptor identification code'],
      ['043', 'Card acceptor name/location'],
      ['044', 'Additional response data'],
      ['045', 'Track 1 data'],
      ['046', 'Additional data - ISO'],
      ['047', 'Additional data - national'],
      ['048', 'Additional data - private'],
      ['049', 'Currency code, transaction'],
      ['050', 'Currency code, settlement'],
      ['051', 'Currency code, cardholder billing'],
      ['052', 'Personal identification number data'],
      ['053', 'Security related control information'],
      ['054', 'Additional amounts'],
      ['055', 'ICC Data - EMV having multiple tags'],
      ['056', 'Reserved ISO'],
      ['057', 'Reserved national'],
      ['058', 'Reserved national'],
      ['059', 'Reserved national'],
      ['060', 'Reserved national'],
      ['061', 'Reserved private (Ex: CVV2/Service Code)'],
      ['062', 'Reserved private (Invoice Number, TPK Key'],
      ['063', 'Reserved private'],
      ['064', 'Message authentication code (MAC)'],
      ['065', 'Bitmap, extended'],
      ['066', 'Settlement code'],
      ['067', 'Extended payment code'],
      ['068', 'Receiving institution country code'],
      ['069', 'Settlement institution country code'],
      ['070', 'Network management information code'],
      ['071', 'Message number'],
      ['072', 'Message number, last'],
      ['073', 'Date, action (YYMMDD)'],
      ['074', 'Credits, number'],
      ['075', 'Credits, reversal number'],
      ['076', 'Debits, number'],
      ['077', 'Debits, reversal number'],
      ['078', 'Transfer number'],
      ['079', 'Transfer, reversal number'],
      ['080', 'Inquiries number'],
      ['081', 'Authorizations, number'],
      ['082', 'Credits, processing fee amount'],
      ['083', 'Credits, transaction fee amount'],
      ['084', 'Debits, processing fee amount'],
      ['085', 'Debits, transaction fee amount'],
      ['086', 'Credits, amount'],
      ['087', 'Credits, reversal amount'],
      ['088', 'Debits, amount'],
      ['089', 'Debits, reversal amount'],
      ['090', 'Original data elements'],
      ['091', 'File update code'],
      ['092', 'File security code'],
      ['093', 'Response indicator'],
      ['094', 'Service indicator'],
      ['095', 'Replacement amounts'],
      ['096', 'Message security code'],
      ['097', 'Amount, net settlement'],
      ['098', 'Payee'],
      ['099', 'Settlement institution identification code'],
      ['100', 'Receiving institution identification code'],
      ['101', 'File name'],
      ['102', 'Account identification 1'],
      ['103', 'Account identification 2'],
      ['104', 'Transaction description'],
      ['105', 'Reserved for ISO use'],
      ['106', 'Reserved for ISO use'],
      ['107', 'Reserved for ISO use'],
      ['108', 'Reserved for ISO use'],
      ['109', 'Reserved for ISO use'],
      ['110', 'Reserved for ISO use'],
      ['111', 'Reserved for ISO use'],
      ['112', 'Reserved for national use'],
      ['113', 'Reserved for national use'],
      ['114', 'Reserved for national use'],
      ['115', 'Reserved for national use'],
      ['116', 'Reserved for national use'],
      ['117', 'Reserved for national use'],
      ['118', 'Reserved for national use'],
      ['119', 'Reserved for national use'],
      ['120', 'Reserved for private use'],
      ['121', 'Reserved for private use'],
      ['122', 'Reserved for private use'],
      ['123', 'Reserved for private use'],
      ['124', 'Reserved for private use'],
      ['125', 'Reserved for private use'],
      ['126', 'Reserved for private use'],
      ['127', 'Reserved for private use'],
      ['128', 'Message authentication code'],
    ]

    return fieldDefinitions.map(([fieldNumber, description], index) => ({
      fieldId: index + 1,
      fieldNumber,
      description,
      isSelected: false,
      value: '',
    }))
  }

  public static calculateBitmap(fields: IsoField[]): string {
    const bitmap = new Array(128).fill(0)
    fields.forEach((f) => {
      if (f.isSelected) bitmap[f.fieldId - 1] = 1
    })
    return this.bitsToHex(bitmap)
  }

  public static parseBitmap(raw: string, fields: IsoField[]): IsoField[] {
    const bits = this.hexToBits(raw)
    return fields.map((f, idx) => ({
      ...f,
      isSelected: bits[idx] === 1,
    }))
  }

  public static sanitizeHexInput(input: string, maxLen: number = 32): string {
    return input
      .toUpperCase()
      .replace(/[^0-9A-F]/g, '')
      .slice(0, maxLen)
  }

  private static bitsToHex(bits: number[]): string {
    let hex = ''
    for (let i = 0; i < bits.length; i += 4) {
      const chunk = bits.slice(i, i + 4).join('')
      hex += parseInt(chunk, 2).toString(16).toUpperCase()
    }
    return hex
  }

  private static hexToBits(hex: string): number[] {
    const bits: number[] = []
    for (let i = 0; i < hex.length; i++) {
      const nibble = parseInt(hex[i], 16).toString(2).padStart(4, '0')
      nibble.split('').forEach((b) => bits.push(Number(b)))
    }
    return bits
  }
}
